/** キー入力を操作（Action）に変換する */
import { KEYMAP, type Action } from './keymap';

const CODE_TO_ACTION = new Map<string, Action>();
for (const [action, codes] of Object.entries(KEYMAP) as [Action, string[]][]) {
  for (const code of codes) CODE_TO_ACTION.set(code, action);
}

export function bindKeyboard(target: Window, onAction: (action: Action) => void): () => void {
  const handler = (e: KeyboardEvent): void => {
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
    const action = CODE_TO_ACTION.get(e.code);
    if (!action) return;
    e.preventDefault();
    onAction(action);
  };
  target.addEventListener('keydown', handler);
  return () => target.removeEventListener('keydown', handler);
}
